<template>
  <div>
    <b-modal
      id="notification"
      v-model="showModal"
      :title="iTitle"
      centered
      ok-only
      @ok="onOkayHandler"
      @hidden="onOkayHandler"
    >
      <div>{{ iText }}</div>
    </b-modal>
  </div>
</template>

<script>
import errorCodes from "../helper/errorCodes";
export default {
  name: "Notification",
  props: {
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    show: { type: Boolean, default: false },
    error: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      iTitle: "",
      iText: "",
    };
  },
  watch: {
    show: {
      handler: function (newVal) {
        this.showModal = newVal;
      },
      immediate: true,
    },
    title: {
      handler: function (newVal) {
        this.iTitle = newVal;
      },
      immediate: true,
    },
    text: {
      handler: function (newVal) {
        this.iText = newVal;
      },
      immediate: true,
    },
    error: {
      handler: function (e) {
        console.log("error in notification", e);
        if (
          typeof e.status !== "undefined" &&
          this.title === "" &&
          this.text === ""
        ) {
          if (e.status === 404) {
            this.iTitle = this.$ml.get("title404");
            this.iText = this.$ml.get("text404");
          } else if (e.status === 401) {
            //let code = e.data.data.code;
            this.iTitle = this.$ml.get("title401");
            this.iText = this.$ml.get(`${e.data.data.code}`);
          } else if (e.status === 400) {
            this.iTitle = this.$ml.get("titleGeneral");
            this.iText = this.$ml.get(`${e.data.data.code}`);
          } else {
            console.log("general error showed");
            this.iTitle = this.$ml.get("titleGeneral");
            this.iText = this.$ml.get("textGeneral");
          }
        } else if (this.title === "" && this.text === "") {
          this.iTitle = this.$ml.get("titleGeneral");
          this.iText = this.$ml.get("textGeneral");
        }
      },
      immediate: true,
    },
  },
  methods: {
    onOkayHandler() {
      this.$emit("okay");
    },
  },
};
</script>

<style scoped></style>
